import React from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'

import { CuppingSessionResultSample } from '../../types/cuppingResult'
import { CuppingSession } from '../../types/cuppingSession'
import { calculateSampleScore } from '../../utils/cuppingUtils'
import CuppingSampleHeader from './cuppingSampleHeader'

interface SummaryTableProps {
  scores: Array<CuppingSessionResultSample>
  session: CuppingSession
}

const SummaryTable = (props: SummaryTableProps): JSX.Element => {
  return (
    <Stack>
      {props.session.cupping_samples.map((sample, index) => {
        const sampleScores = props.scores.find((score) => score.cupping_session_sample === sample.id)
        return (
          <Stack key={sample.id} sx={{ mb: 3 }}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h5" sx={{ mr: 1 }}>
                <CuppingSampleHeader session={props.session} index={index} />
              </Typography>
              {!!props.session.cupping_form_data.score_calculation && sampleScores && (
                <Typography variant="h4">{calculateSampleScore(props.session, sampleScores.scores)}</Typography>
              )}
            </Stack>
            {props.session.cupping_form_data.form_fields.map((field) => {
              const fieldScore = sampleScores?.scores.find((scoreField) => scoreField.cupping_form_field === field.id)
              const fieldScoreLabel =
                field.field_values.find((value) => value.value === fieldScore?.score)?.label || 'N/A'
              return (
                <Stack
                  key={`${sample.id}-${field.id}`}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-end"
                >
                  <Typography>{field.field_label}</Typography>
                  <Typography>{fieldScoreLabel}</Typography>
                </Stack>
              )
            })}
            <Stack direction="row" alignItems="flex-start" flexWrap="wrap">
              {sampleScores?.descriptors?.map((descriptor) => {
                return <Chip key={descriptor.id} sx={{ mr: 1, mb: 1 }} label={`${descriptor.name}`} />
              })}
            </Stack>
            <Stack>{sampleScores?.notes}</Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}

export default SummaryTable
